<template>
    <md-button
        v-if="!isReadOnlyUser"
        title="Delete invoice"
        class="md-danger md-just-icon md-round"
        @click.stop="handleDeleteInvoice()"
    >
        <md-icon>delete</md-icon>
    </md-button>
</template>

<script>
import { GeneralMixin } from '@/mixins/GeneralMixin';
import { handleRequests, showErrorMessage } from '@/helpers';
import { mapGetters } from 'vuex';

export default {
    name: 'DeleteInvoiceButton',
    props: {
        invoiceId: {
            type: [Number, String],
            default: () => null
        },
        status: {
            type: String,
            default: ''
        },
        isBulk: {
            type: Boolean,
            default: false
        },
        bulkTeamMemberInvoiceIds: {
            type: Array,
            default: () => []
        }
    },
    mixins: [GeneralMixin],
    computed: {
        ...mapGetters({
            isReadOnlyUser: 'user/isReadOnlyUser'
        })
    },
    methods: {
        handleDeleteInvoice() {
            let message = 'Are you sure you want to delete this invoice?';

            if (this.isBulk) {
                message = 'Are you sure you want to delete these invoices?';
            }

            this.$messageBox
                .show({
                    class: 'sm-modal-container',
                    title: 'Delete Invoice',
                    body: message,
                    buttons: ['Confirm', 'Cancel']
                })
                .then(async (response) => {
                    if (response.toLowerCase() === 'confirm') {
                        if (this.isBulk) {
                            await this.handleBulkDelete();
                        } else {
                            await this.handleConfirmDelete();
                        }
                    }
                });
        },
        async handleConfirmDelete() {
            if (this.invoiceId == null) {
                showErrorMessage(this, 'No invoice selected');
                return;
            }

            this.$_handleLoaderState(true, 'DELETING...');
            const payload = {
                method: 'delete'
            };
            const api = `/api/team-member-invoices/${this.invoiceId}`;

            try {
                await handleRequests(api, payload);
                this.$notifySuccess('Invoice was deleted!');
                this.$emit('invoiceDeleted', { result: true, invoiceId: this.invoiceId });
            } catch (e) {
                const message = 'Error in deleting the invoice.';
                showErrorMessage(this, message, e);
            }
            this.$_handleLoaderState(false);
        },
        async handleBulkDelete() {
            this.$_handleLoaderState(true, 'DELETING...');
            const payload = {
                method: 'delete',
                data: this.bulkTeamMemberInvoiceIds
            };
            const api = `/api/team-member-invoices/bulk/delete`;

            try {
                await handleRequests(api, payload);
                this.$notify({
                    message: 'Invoices were successfully deleted!',
                    type: 'success'
                });
                this.$emit('invoiceBulkDelete', { result: true, ids: this.bulkTeamMemberInvoiceIds });
            } catch (e) {
                const message = 'Error in deleting the invoices';
                showErrorMessage(this, message, e);
                this.$emit('invoiceBulkDelete', { result: false, ids: this.bulkTeamMemberInvoiceIds });
            }
            this.$_handleLoaderState(false);
        }
    }
};
</script>
<style lang="scss" scoped>
.button-disabled {
    opacity: 0.2 !important;
    cursor: not-allowed;
    pointer-events: all !important;
}
</style>
